import constants from '../constants';
import trackEvent from './track-event';

const { events } = constants;

const trackPageManagerSearchClicked = () => {
  trackEvent(events.PAGE_MANAGER_SEARCH_CLICKED);
};

export default trackPageManagerSearchClicked;
